import { inject, InjectionToken } from '@angular/core';
import { MsalGuard } from '@azure/msal-angular';
import { MonitoringService } from '../services';
export const HAS_MSAL = new InjectionToken('Has MSAL');
export const optionalAuthGuard = (route, state) => {
  const monitoringService = inject(MonitoringService);
  monitoringService.sendTrackEvent('optionalAuthGuard', 'canActivate');
  return inject(HAS_MSAL) ? inject(MsalGuard).canActivate(route, state) : true;
};
